import React from "react";

import CustomCheckbox from "../../../inputs/CustomCheckbox";

const RowAttribute = ({ row, attributesPicked, handlePickedAttribute }) => {
  const checked = attributesPicked.includes(row.id);

  return (
    <div className="attributes-row flex align-center pointer" onClick={() => handlePickedAttribute(row)}>
      <div className="attributes-row-checkbox flex-center">
        <CustomCheckbox
          checked={checked}
          handleChange={() => handlePickedAttribute(row)}
          customClass="attributes-checkbox"
        />
      </div>

      <div className="attributes-row-name flex">
        <span className="attributes-row-text">{row.name}</span>
      </div>

      <div className="attributes-row-type flex">
        <span className="attributes-row-text">{row.internal ? "internal" : "external"}</span>
      </div>

      <div className="attributes-row-description flex">
        <span className="attributes-row-text">{row.description}</span>
      </div>

      <div className="attributes-row-component flex">
        <span className="attributes-row-text">{row.componentName}</span>
      </div>

      <div className="attributes-row-importance flex">
        <span className="attributes-row-text">{row.importance}</span>
      </div>

      <div className="attributes-row-project flex">
        <span className="attributes-row-text">{row.productName}</span>
      </div>
    </div>
  );
};

export default RowAttribute;
